module.exports = __webpack_public_path__ + "static/9-3de81d7127b77190623ee5e86ae8d411.svg";